<template>
  <div style="height: inherit">
    <b-card
      no-body
      class="card-browser-states"
    >
      <b-card-header>
        <div>
          <b-card-title>Visor de Mapas</b-card-title>
        </div>
      </b-card-header>
      <b-card-body>
        <div id="map">
          <b-row
            v-if="stateMapa"
          >
            <gmap-map
              ref="map"
              :center="center"
              map-type-id="terrain"
              :zoom="16"
              style="width: 100%; height: 800px"
            >
              <div
                v-if="stateMapaContent"
              >
                <gmap-marker
                  v-for="(m, index) in markers"
                  :key="index"
                  :position="m.position"
                  :title="m.title"
                  :clickable="true"
                  :draggable="true"
                  :icon="markerOptions"
                  @click="toggleInfoWindow(m,index)"
                />
                <gmap-info-window
                  :options="infoOptions"
                  :position="infoWindowPos"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen=false"
                >
                  <div class="container">
                    <div class="row">
                      <div
                        class="col-sm-12"
                        style="max-width: 316px !important;max-height: 500px !important;"
                      >
                        <b-card
                          v-if="infoContent"
                          no-body
                          class="card-developer-meetup"
                        >
                          <div class="bg-light-primary rounded-top text-center">
                            <b-img
                              v-if="(infoContent.multimedia.length > 0)"
                              :src="`data:image/jpeg;base64,${infoContent.multimediaStartLogo}`"
                              alt="Imagen"
                              style="height:143.1px;max-height: 143.1px;max-width: 285px;"
                            />
                          </div>
                          <b-card-body>
                            <!-- metting header -->
                            <div class="meetup-header d-flex align-items-center">
                              <div class="meetup-day">
                                <h6 class="mb-0">
                                  {{ infoContent.dayShort.toUpperCase() }}
                                </h6>
                                <h3 class="mb-0">
                                  {{ infoContent.dateNumber }}
                                </h3>
                              </div>
                              <div class="my-auto">
                                <b-card-title
                                  class="mb-25"
                                  style="font-size: 1.0rem !important"
                                >
                                  {{ infoContent.titulo }}
                                </b-card-title>
                                <b-card-text
                                  class="mb-0"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  :title="infoContent.fullDescripcion"
                                >
                                  {{ infoContent.descripcion }}
                                </b-card-text>
                              </div>
                            </div>
                            <!--/ metting header -->

                            <!-- media -->
                            <b-media
                              no-body
                            >
                              <b-media-aside class="mr-1">
                                <b-avatar
                                  rounded
                                  variant="light-primary"
                                  size="34"
                                >
                                  <feather-icon
                                    icon="CalendarIcon"
                                    size="18"
                                  />
                                </b-avatar>
                              </b-media-aside>
                              <b-media-body>
                                <h6 class="mb-0">
                                  {{ infoContent.createdAt }}
                                </h6>
                                <small>
                                  {{ infoContent.hour }}
                                </small>
                              </b-media-body>
                            </b-media>

                            <!-- avatar group -->
                            <b-avatar-group
                              class="mt-2 pt-50"
                              size="33"
                            >
                              <b-avatar
                                v-for="mult in infoContent.multimedia"
                                :key="mult.idMultimedia"
                                v-b-tooltip.hover.bottom="mult.nombre"
                                :src="`data:image/jpeg;base64,${mult.url}`"
                                class="pull-up"
                                button
                                @click="loadImgMultimedia(mult.url)"
                              />
                              <!-- <h6 class="align-self-center cursor-pointer ml-1 mb-0">
                                +0
                              </h6> -->
                            </b-avatar-group>
                          </b-card-body>
                          <br>
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                class="btn btn-primary btn-block"
                                @click="loadTracking(infoContent)"
                              >
                                GENERAR TRACKING
                              </button>
                            </div>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </gmap-info-window>
              </div>
            </gmap-map>
          </b-row>
        </div>
        <div
          v-show="trackingShow"
          id="floating-tracking"
          class="floating-tracking"
        >
          <tracking
            ref="refTrackingForm"
            :is-busy-tracking.sync="isBusyTracking"
            :is-add-new-user-active.sync="isAddNewActive"
            :data-ficha="dataTracking"
            :tracking-show.sync="trackingShow"
            @refetch-data="refetchDataTracking"
            @error-data="showError"
          />
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import store from '@/store'
import { BCard, BCardHeader, BCardTitle, BCardBody, BRow, BImg, BCardText, BMedia, BMediaAside, BAvatar, BAvatarGroup, BMediaBody, VBTooltip } from 'bootstrap-vue'
import moment from 'moment'
import { _ } from 'vue-underscore'
import imgMarker from '../../../assets/images/encuesta/pin3.png'
import Tracking from './Tracking.vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BImg,
    BCardText,
    BMedia,
    BMediaAside,
    BAvatar,
    BAvatarGroup,
    BMediaBody,
    Tracking,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    latitude: {
      type: Number,
      default: -6.0220945,
    },
    longitude: {
      type: Number,
      default: -76.9884157,
    },
    title: {
      type: String,
      default: 'Título de Marcador',
    },
    dataMapa: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      unsubscribe3: null,
      modalShowRespuesta: false,
      isBusyRespuesta: false,
      titleModalRespuesta: 'Resultado de la Encuesta',
      typeAction: 'ver',
      dataRespuesta: {},
      time1: '',
      isBusyTracking: false,
      isAddNewActive: false,
      itemsFicha: [],
      dataTracking: {},
      trackingShow: false,
      stateMapaContent: false,
      stateMapa: true,
      sortByFicha: null,
      fieldsFicha: [
        { key: 'index', label: '#' },
        { key: 'time', label: 'Ejecución' },
        { key: 'longitud', label: 'Coordenadas' },
        { key: 'encuestado', label: 'Encuestado' },
        { key: 'validadoReniec', label: 'validadoReniec' },
        { key: 'observacion', label: 'observacion' },
        { key: 'op' },
        // { key: 'fechaRetomo', label: 'retomo' },
      ],
      markerOptions: {
        url: imgMarker,
        // size: { width: 50, height: 50, f: 'px', b: 'px' },
        // scaledSize: { width: 50, height: 50, f: 'px', b: 'px' },
      },
      markers: [],
      center: { lat: this.latitude, lng: this.longitude },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      currentMidx: null,
      infoWinOpen: false,
    }
  },
  created() {
    this.generateMapa(this.$store.state.gsencuesta.datMap)
    /* this.unsubscribe3 = this.$store.subscribe(mutation => {
      if (this.$store.state.gsencuesta.operacion === 'show') {
        console.log(mutation.payload.datMap)
        // this.dataGeneralUbigeo = mutation.payload.data
      } else {
        console.log('hola')
      }
    }) */
  },
  /* destroyed() {
    this.unsubscribe3()
  }, */
  methods: {
    okMdlRespuesta(ev) {
      ev.preventDefault()
    },
    refetchDataRespuesta(response) {
      console.log(response)
    },
    getRespuesta(data) {
      store
        .dispatch('gsencuesta/TABLERO_INDICADOR_PREGUNTA_RESPUESTA', {
          idFicha: data.item.idFicha,
        })
        .then(response => {
          if (response !== undefined) {
            this.titleModalRespuesta = 'Resultado de Encuesta'
            this.modalShowRespuesta = true
            this.dataRespuesta = response.data
          }
        })
        .catch(() => {
          // notify(error, 'He ocurrido un error', 'danger')
        })
    },
    loadImgMultimedia(url) {
      this.infoContent.multimediaStartLogo = url
    },
    loadTracking(ficha) {
      this.trackingShow = true
      this.$refs.map.$mapPromise.then(map => {
        let indexArray = null
        const bottomCenterControls = map.controls[window.google.maps.ControlPosition.TOP_CENTER]
        bottomCenterControls.forEach((element, index) => {
          if (!_.isUndefined(element)) {
            if (element.id !== null && element.id === 'floating-tracking') {
              indexArray = index
            }
          }
        })
        if (!_.isNull(indexArray) || indexArray) {
          // bottomCenterControls.removeAt(indexArray)
        }
        const myControl = document.getElementById('floating-tracking')// floating-panel
        myControl.index = 1 // Esto es importante sino arroja error.
        map.controls[window.google.maps.ControlPosition.TOP_CENTER].setAt(1, myControl)
        this.dataTracking = ficha
        this.isBusyTracking = true
        this.isAddNewActive = true
        this.$refs.refTrackingForm.dataForm(ficha)
      })
    },
    refetchDataTracking() {
      this.trackingShow = false
    },
    generateMapa(item) {
      this.stateMapa = false
      let stateFicha = false
      if (item !== null) {
        this.time1 = '0 min'
        this.markers = []
        this.stateMapaContent = true
        this.stateMapa = true
        this.itemsFicha = []
        const ff = (!item.fechaFin || item.fechaFin === null) ? '' : moment(item.fechaFin).format('YYYY-MM-DD')
        const fechaStart = (!item.fechaInicio || item.fechaInicio === null) ? '' : moment(item.fechaInicio).locale('es').format('YYYY-MM-DD')
        const fechaEnvio = (!item.fechaEnvio || item.fechaEnvio === null) ? '' : moment(item.fechaEnvio).locale('es').format('YYYY-MM-DD') //  h:mm:ss a
        const fechaRetomo = (!item.fechaRetomo || item.fechaRetomo === null) ? '' : moment(item.fechaRetomo).locale('es').format('YYYY-MM-DD')
        const a = moment(item.fechaInicio)
        const b = moment(item.fechaFin)
        const m = b.diff(a, 'minutes')
        const textMin = (m > 1) ? 'Minutos' : 'Minuto'
        this.time1 = `${m} ${textMin}`
        const row = {
          index: 1,
          idFicha: item.idFicha,
          position: { lat: parseFloat(item.latitud), lng: parseFloat(item.longitud) },
          title: item.encuestado.nombre,
          encuestado: item.encuestado,
          fechaFin: ff,
          fechaInicio: item.fechaInicio,
          latitud: item.latitud,
          longitud: item.longitud,
          createdAt: item.createdAt,
          encuesta: item.encuesta,
          multimedia: item.multimedia,
          tracking: item.tracking,
          time: this.time1,
          observacion: (item.observacion === null || item.observacion === 'null') ? '' : item.observacion,
          fechaStart,
          fechaEnvio,
          fechaRetomo,
          latitudRetomo: (item.latitudRetomo === null) ? '' : item.latitudRetomo,
          longitudRetomo: (item.longitudRetomo === null) ? '' : item.longitudRetomo,
        }
        this.markers.push(row)
        this.itemsFicha.push(row)
        this.stateMapaContent = true
        stateFicha = true
      }
      this.$emit('refetch-data', stateFicha)
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    toggleInfoWindow(marker, idx) {
      moment.locale('es')
      this.infoWindowPos = marker.position
      let descripcionSurvey = `${marker.encuestado.nombre} ${marker.encuestado.apellidoPaterno} ${marker.encuestado.apellidoMaterno}` // marker.encuesta.descripcion
      const localLocale = moment(marker.fechaInicio) // createdAt
      const dateCreate = moment(localLocale).locale('es').format('dddd, LL')
      let dayShort = moment(localLocale).locale('es').format('dddd')
      const hour = moment(localLocale).locale('es').format('h:mm:ss a')
      dayShort = dayShort.substring(0, 3)
      const dateNumber = moment(marker.createdAt).locale('es').format('DD')
      if (descripcionSurvey.length > 57) {
        descripcionSurvey = descripcionSurvey.substring(0, 57)
        descripcionSurvey = `${descripcionSurvey} ...`
      }
      // console.log(`daat ${descripcionSurvey}`)
      this.infoContent = {
        idFicha: marker.idFicha,
        multimedia: marker.multimedia,
        multimediaStartLogo: (marker.multimedia.length > 0) ? marker.multimedia[0].url : `https://apimesa.regionsanmartin.gob.pe/gsencuesta/api/v1/recurso/encuesta/${marker.encuesta.idEncuesta}/thumbnail`,
        descripcion: descripcionSurvey,
        fullDescripcion: marker.encuestado.direccion, // marker.encuesta.descripcion,
        titulo: marker.encuestado.documento, // marker.encuesta.titulo,
        createdAt: dateCreate,
        time: marker.time,
        hour,
        dateNumber,
        dayShort,
        latitud: marker.latitud, // para centrar en tracking
        longitud: marker.longitud, // para centrar en tracking
        tracking: marker.tracking, // PASAMOS TODO EL TRAKCING ALLA VALIDAMOS SI HAY TRACKING
      }
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.floating-panel{
    position: absolute !important;
    top: 10px !important;
    z-index: 5 !important;
    left: 24% !important;
    width: 50% !important;
}
.floating-tracking{
    position: absolute !important;
    left: 0% !important;
    top: 10px !important;
    z-index: 5 !important;
    width: 100% !important;
}
.table.table-xsmall > thead > th,
.table.table-xsmall > tfoot > th,
.table.table-xsmall > tbody > td,
.table.table-xsmall > tbody > th {
  padding: 0.1rem;
}
</style>
